module.exports = __webpack_public_path__ + "static/img/Group5.f6f42af1.png";